export default __webpack_public_path__ + "static/media/topsecret2.01196c7e.png";